import { Navigate, Route, Routes, useNavigate } from "react-router-dom"
import Login from "./Auth/Login.js"
import Registration from "./Register/Registration.js"
import { useDispatch, useSelector } from "react-redux"
import Header from "./Header/index.js"
import { useEffect } from "react"
// import { setAxiosInterceptors } from "../services/axios.js"
import ForgotPassword from "./Auth/forgotPassword.js"
import OtpScreen from "./Auth/otpScreen.js"
import Schedule from "./Schedule/index.js"
import CommonUsers from "./Register/CommonUsers.js"
import ChangePassword from "./Auth/changePassword.js"
import { GetUserInfo } from "./GlobalComponents/CommonComponents.js"
import Invoice from "./Invoice/index.js"
import { setUserData } from "../redux/reducer/appReducer.js"

const Router = () => {
  const { isUserLoggedIn } = useSelector((state) => state.app.userData)
  const { canShowAll } = GetUserInfo()
  const dispatch = useDispatch()

  const navigate = useNavigate()
  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken")
    if (!accessToken) {
      navigate("/", { replace: true })
      dispatch(setUserData({}))
    }
    // setAxiosInterceptors(navigate)
  }, [])

  if (!isUserLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/registration" element={<Registration />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/patient" element={<CommonUsers />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/otpScreen" element={<OtpScreen />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/invoice" element={<Invoice />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    )
  }

  return (
    <>
      {/* <Routes>
                <Route path="/" element={<Login />} />
            </Routes> */}

      <Header />
      <Routes>
        {/* <Route path="/" element={<Login />} /> */}
        {canShowAll && <Route path="/registration" element={<Registration />} />}
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/patient" element={<CommonUsers />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/otpScreen" element={<OtpScreen />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/invoice" element={<Invoice />} />

        <Route path="*" element={<Navigate to="/patient" />} />
      </Routes>
    </>
  )
}

export default Router
